import { render, staticRenderFns } from "./BdCode.vue?vue&type=template&id=601ca4f4&scoped=true&"
import script from "./BdCode.vue?vue&type=script&lang=js&"
export * from "./BdCode.vue?vue&type=script&lang=js&"
import style0 from "./BdCode.vue?vue&type=style&index=0&id=601ca4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601ca4f4",
  null
  
)

export default component.exports